module.exports = __webpack_public_path__ + "img/banner_desktop.afd31c8c.jpeg";